<div class="form-page">
  <section class="hero">
    <img src="assets/imgs/portada.png" alt="Inscripcion a cursos" class="hero-image" />
  </section>

  <form class="form-container">
    @if (templateStructure.mostrarAntecedentes) {
      <mat-card class="form-card">
        <mat-card-header>
          <span mat-card-avatar class="section-icon"><mat-icon>person_outline</mat-icon></span>
          <mat-card-title>Antecedentes de Contacto</mat-card-title>
        </mat-card-header>
        <mat-card-content class="field-grid">
          @if (templateStructure.mostrarAntecedenteNombre) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>person_outline</mat-icon>
              <mat-label>Nombre completo *</mat-label>
              <input matInput [(ngModel)]="antecedente.name" name="ant_name" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarAntecedenteCedula) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>badge</mat-icon>
              <mat-label>Cedula de identidad</mat-label>
              <input matInput [(ngModel)]="antecedente.cedula" name="ant_cedula" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarAntecedenteEmail) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>mail_outline</mat-icon>
              <mat-label>E-mail de contacto *</mat-label>
              <input matInput [(ngModel)]="antecedente.email" name="ant_email" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarAntecedenteComuna) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>location_on</mat-icon>
              <mat-label>Comuna/Ciudad *</mat-label>
              <input matInput [(ngModel)]="antecedente.comuna" name="ant_comuna" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarAntecedentePais) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>public</mat-icon>
              <mat-label>Pais</mat-label>
              <input matInput [(ngModel)]="antecedente.region" name="ant_region" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarAntecedenteTelefono) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>call</mat-icon>
              <mat-label>Telefono fijo</mat-label>
              <input matInput [(ngModel)]="antecedente.telefono" name="ant_tel" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarAntecedenteCelular) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>phone_iphone</mat-icon>
              <mat-label>Celular</mat-label>
              <input matInput [(ngModel)]="antecedente.celular" name="ant_cel" />
            </mat-form-field>
          }
        </mat-card-content>
      </mat-card>
    }

    @if (templateStructure.mostrarCursos) {
      <mat-card class="form-card">
        <mat-card-header>
          <span mat-card-avatar class="section-icon"><mat-icon>menu_book</mat-icon></span>
          <mat-card-title>Cursos solicitados</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="data-table courses-table">
            <div class="table-header">
              <span>N&deg;</span>
              <span>Curso *</span>
              <span>Cantidad de personas *</span>
              <span></span>
            </div>
            @for (curso of cursos_solicitados; track customTrackBy(i, curso); let i = $index) {
              <div class="table-row">
                <span class="row-number">{{ i + 1 }}</span>
                @if (templateStructure.mostrarCursoNombre) {
                  <mat-form-field appearance="outline">
                    <mat-label>Seleccione o escriba el curso</mat-label>
                    <input matInput [(ngModel)]="curso.curso" name="curso{{i}}" />
                  </mat-form-field>
                }
                @if (templateStructure.mostrarCursoPersonas) {
                  <mat-form-field appearance="outline">
                    <mat-label>0</mat-label>
                    <input matInput type="number" [(ngModel)]="curso.personas" name="cant{{i}}" />
                  </mat-form-field>
                }
                @if (cursos_solicitados.length > 1) {
                  <button mat-icon-button class="delete-button" aria-label="Quitar curso" type="button" (click)="delcurso()"
                    >
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                }
              </div>
            }
          </div>
          <button mat-stroked-button class="add-button" type="button" (click)="addcurso()">
            <mat-icon>add</mat-icon>
            Agregar curso
          </button>
        </mat-card-content>
      </mat-card>
    }

    @if (templateStructure.mostrarParticipantes) {
      <mat-card class="form-card">
        <mat-card-header>
          <span mat-card-avatar class="section-icon"><mat-icon>groups</mat-icon></span>
          <mat-card-title>Participantes al curso</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="data-table participants-table">
            <div class="table-header">
              <span>N&deg;</span>
              <span>Nombre y Apellidos *</span>
              <span>Correo electronico *</span>
              <span>N&deg; CI *</span>
              <span>Cargo</span>
              <span>N&deg; Curso (*)</span>
              <span></span>
            </div>
            @for (participante of participantes; track customTrackBy(i, participante); let i = $index) {
              <div class="table-row">
                <span class="row-number">{{ i + 1 }}</span>
                @if (templateStructure.mostrarParticipanteNombre) {
                  <mat-form-field appearance="outline">
                    <mat-label>Nombre y Apellidos</mat-label>
                    <input matInput [(ngModel)]="participante.name" name="pname{{i}}" />
                  </mat-form-field>
                }
                @if (templateStructure.mostrarParticipanteEmail) {
                  <mat-form-field appearance="outline">
                    <mat-label>correo&#64;ejemplo.com</mat-label>
                    <input matInput [(ngModel)]="participante.email" name="pemail{{i}}" />
                  </mat-form-field>
                }
                @if (templateStructure.mostrarParticipanteCi) {
                  <mat-form-field appearance="outline">
                    <mat-label>N&deg; CI</mat-label>
                    <input matInput [(ngModel)]="participante.ci" name="pci{{i}}" />
                  </mat-form-field>
                }
                @if (templateStructure.mostrarParticipanteRol) {
                  <mat-form-field appearance="outline">
                    <mat-label>Cargo</mat-label>
                    <input matInput [(ngModel)]="participante.rol" name="prol{{i}}" />
                  </mat-form-field>
                }
                @if (templateStructure.mostrarParticipanteCurso) {
                  <mat-form-field appearance="outline">
                    <mat-label>N&deg; Curso</mat-label>
                    <input matInput [(ngModel)]="participante.curso" name="pcurso{{i}}" />
                  </mat-form-field>
                }
                @if (participantes.length > 1) {
                  <button mat-icon-button class="delete-button" aria-label="Quitar participante" type="button"
                    (click)="delpart()">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                }
              </div>
            }
          </div>
          <button mat-stroked-button class="add-button" type="button" (click)="addpart()">
            <mat-icon>add</mat-icon>
            Agregar participante
          </button>
        </mat-card-content>
      </mat-card>
    }

    @if (templateStructure.mostrarAntecedentesEmpresa) {
      <mat-card class="form-card">
        <mat-card-header>
          <span mat-card-avatar class="section-icon"><mat-icon>apartment</mat-icon></span>
          <mat-card-title>Datos de la Empresa</mat-card-title>
        </mat-card-header>
        <mat-card-content class="field-grid company-grid">
          @if (templateStructure.mostrarEmpresaRazon) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-icon matPrefix>business</mat-icon>
              <mat-label>Razon social (*)</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.razon" name="emp_razon" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarEmpresaGiro) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>work_outline</mat-icon>
              <mat-label>Giro (*)</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.giro" name="emp_giro" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarEmpresaRut) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>badge</mat-icon>
              <mat-label>RUT/RUC (*)</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.rut" name="emp_rut" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarEmpresaEncargado) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-icon matPrefix>person_outline</mat-icon>
              <mat-label>Encargado de facturas y pagos (*)</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.encargado" name="emp_encargado" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarEmpresaEmail) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-icon matPrefix>mail_outline</mat-icon>
              <mat-label>E-mail (*)</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.email" name="emp_email" />
            </mat-form-field>
          }
          <mat-form-field appearance="outline" class="full-width">
            <mat-icon matPrefix>location_on</mat-icon>
            <mat-label>Direccion</mat-label>
            <textarea matInput rows="3" [(ngModel)]="antecedente_emp.direccion" name="emp_direccion"></textarea>
          </mat-form-field>
          @if (templateStructure.mostrarEmpresaComuna) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>location_on</mat-icon>
              <mat-label>Comuna/Ciudad</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.comuna" name="emp_comuna" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarEmpresaRegion) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>public</mat-icon>
              <mat-label>Pais</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.region" name="emp_region" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarEmpresaTelefono) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>call</mat-icon>
              <mat-label>Telefono fijo</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.telefono" name="emp_tel" />
            </mat-form-field>
          }
          @if (templateStructure.mostrarEmpresaCelular) {
            <mat-form-field appearance="outline">
              <mat-icon matPrefix>phone_iphone</mat-icon>
              <mat-label>Celular</mat-label>
              <input matInput [(ngModel)]="antecedente_emp.celular" name="emp_cel" />
            </mat-form-field>
          }
        </mat-card-content>
      </mat-card>
    }

    <mat-card class="submit-card">
      <button mat-raised-button class="submit-button" type="button" (click)="send()" [disabled]="loading">
        <mat-icon>send</mat-icon>
        Enviar inscripcion
      </button>
    </mat-card>
  </form>

  @if (loading) {
    <div class="progress-backdrop" role="status" aria-live="polite" aria-busy="true">
      <div class="progress-panel">
        <mat-progress-spinner
          class="progress-spinner"
          mode="indeterminate"
          diameter="48"
          strokeWidth="4">
        </mat-progress-spinner>
        <div class="progress-copy">
          <strong>{{ progressTitle }}</strong>
          <span>{{ progressMessage }}</span>
        </div>
      </div>
    </div>
  }

  @if (successDialogOpen) {
    <div class="success-backdrop" role="presentation">
      <section class="success-dialog" role="dialog" aria-modal="true" aria-labelledby="success-title">
        <div class="success-sparkles" aria-hidden="true">
          <span class="spark spark-blue spark-1"></span>
          <span class="spark spark-red spark-2"></span>
          <span class="spark spark-yellow spark-3"></span>
          <span class="spark spark-blue spark-4"></span>
          <span class="spark spark-red spark-5"></span>
          <span class="spark spark-yellow spark-6"></span>
        </div>

        <div class="success-icon" aria-hidden="true">
          <mat-icon>check</mat-icon>
        </div>

        <h2 id="success-title">Env&iacute;o exitoso</h2>
        <p>Tu mensaje fue enviado correctamente.</p>

        <button mat-raised-button type="button" class="success-button" (click)="closeSuccessDialog()">
          Aceptar
        </button>
      </section>
    </div>
  }
</div>
